var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback } from 'react';
import { ENTER_KEY, ESCAPE_KEY } from '#constants';
export const useKeyboardHandler = ({ onEnter, onEscape, preventDefault = true, stopPropagation = true, } = {}) => {
    _react_refresh_temp_1();
    const handleKeyboardEvent = useCallback((event) => {
        let isHandled = false;
        switch (event.key) {
            case ENTER_KEY:
                if (onEnter) {
                    onEnter(event);
                    isHandled = true;
                }
                break;
            case ESCAPE_KEY:
                if (onEscape) {
                    onEscape(event);
                    isHandled = true;
                }
                break;
            default:
                break;
        }
        if (isHandled) {
            if (preventDefault) {
                event.preventDefault();
            }
            if (stopPropagation) {
                event.stopPropagation();
            }
        }
    }, [onEnter, onEscape, preventDefault, stopPropagation]);
    return { handleKeyboardEvent };
};
_react_refresh_temp_1(useKeyboardHandler, "DsxUJktISRlACDFSkfAOvkPxEiE=");
